import React from 'react'
import { ButtonWithIcon } from '../Common/Buttons'
import { DeleteIcon, DropDownArrowIcon } from '../../assets/icons/icon'
import { t } from 'i18next'
import { NoMenuItem } from '../Common/DisplayInfo'
import DropDwonImg from '../../assets/images/down_arrow.svg'

const MenuSelectionSection = ({
  title,
  prefix, // "morning" | "afternoon" | "night"
  options,
  setOptions,
  isPopoverOpen,
  closeOtherPopovers,
  togglePopover,
  menuOptionsRef,
  searchInputRef,
  searchText,
  setSearchText,
  filteredMenuLists,
  handleCheckboxChange,
  categoryList,
  selectedCategoryIndex,
  setSelectedCategoryIndex,
  showNextCategory,
  showPreviousCategory,
  dropdownOpen,
  setDropdownOpen,
  categorySearch,
  setCategorySearch,
  categoryOptionsRef,
  setSelectedTime,
  setIsDeleteItem,
  setisOpenDelete
}) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900">{title}</h4>

      {/* SELECT MENU */}
      <div
        className="relative"
        ref={menuOptionsRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="h-12 border rounded-lg px-4 flex items-center cursor-pointer text-sm justify-between hover:border-secondary transition-colors duration-200"
          onClick={(e) => {
            e.stopPropagation()
            togglePopover()
            setTimeout(() => {
              searchInputRef.current?.focus()
            }, 100)
            closeOtherPopovers()
          }}
        >
          <span className="text-gray-600">{t('Sel_menu')}</span>
          <img alt="select" src={DropDwonImg} />
        </div>

        {/* POPOVER */}
        {isPopoverOpen && (
          <div className="absolute w-full top-[52px] left-0 bg-white border rounded-lg p-4 shadow-lg z-50">
            {/* CATEGORY SELECTOR */}
            {categoryList?.length > 0 && (
              <div className="flex items-center justify-between mb-3 gap-4">
                <ButtonWithIcon
                  text="Previous"
                  variant="secondary"
                  btnclass="text-black hover:bg-gray-100 px-1.5 py-0.5 text-xs font-medium"
                  Icon={DropDownArrowIcon}
                  iconClass="rotate-180 mr-1"
                  onClick={showPreviousCategory}
                />
                {/* ============== SEARCHABLE DROPDOWN ============== */}
                <div
                  className="flex flex-col items-center flex-1 relative w-full"
                  ref={categoryOptionsRef}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="w-full p-2 border border-gray-300 rounded-lg text-xs cursor-pointer bg-white flex items-center justify-between"
                  >
                    <span>
                      {categoryList[selectedCategoryIndex]?.categoryName &&
                        categoryList[selectedCategoryIndex]?.categoryNameEn
                        ? `${categoryList[selectedCategoryIndex].categoryName} (${categoryList[selectedCategoryIndex].categoryNameEn})`
                        : categoryList[selectedCategoryIndex]?.categoryName ||
                        categoryList[selectedCategoryIndex]?.categoryNameEn}
                    </span>
                    <DropDownArrowIcon
                      className={`w-4 h-4 ${dropdownOpen ? 'rotate-[270deg]' : 'rotate-90'
                        }`}
                    />
                  </div>

                  {dropdownOpen && (
                    <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-50 p-[2px]">
                      <input
                        type="text"
                        placeholder="Search category..."
                        value={categorySearch}
                        onChange={(e) => setCategorySearch(e.target.value)}
                        className="w-full px-3 py-2 border-b border-gray-200 text-xs focus-within:outline-none"
                      />
                      {/* Filtered Options */}
                      <div className="max-h-48 overflow-y-auto">
                        {categoryList
                          .filter((cat) =>
                            (cat.categoryNameEn + " " + cat.categoryName)
                              .toLowerCase()
                              .includes(categorySearch.toLowerCase())
                          ).length === 0 ? (

                          /* No results message */
                          <div className="px-3 py-4 text-xs text-gray-500 text-center">
                            No categories found
                          </div>
                        ) : (
                          categoryList
                            .filter((cat) =>
                              (cat.categoryNameEn + " " + cat.categoryName)
                                .toLowerCase()
                                .includes(categorySearch.toLowerCase())
                            )
                            .map((cat) => {
                              const index = categoryList.findIndex((c) => c._id === cat._id);
                              const isSelected = index === selectedCategoryIndex;

                              return (
                                <div
                                  key={cat._id}
                                  onClick={() => {
                                    setSelectedCategoryIndex(index);
                                    setDropdownOpen(false);
                                  }}
                                  className={`px-3 py-2 text-xs cursor-pointer flex items-center justify-between ${isSelected ? "bg-green-100 hover:bg-green-100" : "hover:bg-gray-100"}`}
                                >
                                  {/* Category name */}
                                  <span>
                                    {cat.categoryName && cat.categoryNameEn
                                      ? `${cat.categoryName} (${cat.categoryNameEn})`
                                      : cat.categoryName || cat.categoryNameEn}
                                  </span>

                                  {/* Checkmark for selected category */}
                                  {isSelected && (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="2"
                                      stroke="currentColor"
                                      className="w-4 h-4 text-green-600"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                  )}
                                </div>
                              );
                            })
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {/* ============== END SEARCHABLE DROPDOWN ============== */}
                {/* Next Icon */}
                <ButtonWithIcon revers text='Next' variant='secondary' btnclass="text-black hover:bg-gray-100 px-1.5 py-0.5 text-xs font-medium" onClick={showNextCategory} Icon={DropDownArrowIcon} title="Previous" iconClass='mr-0 ml-1' />
              </div>
            )}

            {/* SEARCH */}
            <input
              ref={searchInputRef}
              type="text"
              placeholder={t('search_menu')}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="mb-3 p-3 border border-gray-200 rounded-lg outline-none text-sm w-full focus:border-secondary focus:ring-2 focus:ring-secondary/20"
            />

            {/* MENU LIST */}
            <div className="max-h-48 overflow-auto">
              {filteredMenuLists
                .slice()
                .sort((a, b) => {
                  const aSel = options.some(i => i._id === a._id)
                  const bSel = options.some(i => i._id === b._id)
                  return aSel === bSel ? 0 : aSel ? -1 : 1
                })
                .map((option, index) => {
                  const isSelected = options.some(i => i._id === option._id);
                  const handleSelect = () => {
                    handleCheckboxChange(option);
                    setSearchText('');
                    setTimeout(() => {
                      searchInputRef.current?.focus();
                    }, 0);
                  };

                  return (
                    <div
                      key={index}
                      className="flex items-center p-2 cursor-pointer hover:bg-gray-50 focus:bg-gray-100 outline-none"
                      tabIndex="0"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelect();
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleSelect();
                        }
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => { }} // Managed by parent div's click
                        className="mr-3 pointer-events-none"
                      />
                      <span className="text-sm">
                        {option.menuName && option.menuNameEn
                          ? `${option.menuName} (${option.menuNameEn})`
                          : option.menuName || option.menuNameEn}
                      </span>
                    </div>
                  );
                })}
              {filteredMenuLists.length === 0 && <NoMenuItem />}
            </div>
          </div>
        )}
      </div>

      {/* SELECTED ITEMS */}
      <div className="border rounded-lg max-h-[75vh] overflow-auto">
        <div className="p-4 space-y-2">
          {options.map((menuItem, index) => (
            <div
              key={menuItem._id}
              draggable
              onDragOver={(e) => e.preventDefault()}
              onDragStart={(e) =>
                e.dataTransfer.setData('index', index)
              }
              onDrop={(e) => {
                const oldIndex = parseInt(e.dataTransfer.getData("index"), 10);
                const newIndex = index;

                if (oldIndex === newIndex) return;

                const updatedOptions = [...options];
                const [movedItem] = updatedOptions.splice(oldIndex, 1);
                updatedOptions.splice(newIndex, 0, movedItem);

                setOptions(updatedOptions);
              }}
              className="flex justify-between items-center border p-3 rounded-lg bg-white cursor-move"
            >
              {/* <span className="text-sm font-medium">
                {index + 1}. {menuItem.menuNameEn || menuItem.menuName}
              </span> */}
              <span className="text-sm font-medium">
                {index + 1}.{" "}
                {menuItem.menuName && menuItem.menuNameEn
                  ? `${menuItem.menuName} (${menuItem.menuNameEn})`
                  : menuItem.menuName || menuItem.menuNameEn}
              </span>

              <ButtonWithIcon
                Icon={DeleteIcon}
                btnclass="p-0.5 text-red-600 bg-red-50 rounded-md border border-red-300"
                variant="secondary"
                onClick={() => {
                  setSelectedTime(prefix)
                  setIsDeleteItem(menuItem)
                  setisOpenDelete(true)
                }}
                iconClass='mr-0'
              />
            </div>
          ))}

          {options.length === 0 && <NoMenuItem />}
        </div>
      </div>
    </div>
  )
}

export default MenuSelectionSection
